/** Strings for the checkout plan selector (usage.subscription.checkout). */
export const enSubscriptionCheckout = {
	subheading: "All plans include every feature. Pick the credit volume and team size that fits.",
	savePill: "Save 10%",
	mostPopular: "Most popular",
	creditsPerMonth: "{{credits}} credits / month",
	senders: "{{count}} senders",
	sendersTooltip:
		"1 sender = 1 LinkedIn account + 1 email, used to send messages through Signalist. You can invite unlimited non-sending users (e.g. managers or researchers) at no extra cost. Additional senders & email addresses can be added separately anytime.",
	/** Card titles per credit tier — every Stripe product is named after its interval. */
	tier: {
		starter: "Starter",
		advanced: "Advanced",
		scale: "Scale",
	},
	billedMonthly: "billed monthly",
	billedQuarterlyTotal: "{{amount}} billed quarterly",
	billedHalfYearlyTotal: "{{amount}} billed half-yearly",
	billedYearlyTotal: "{{amount}} billed yearly",
	selectPlan: "Select {{name}}",
	selectedPlan: "Selected plan",
	universals: {
		users: "Unlimited users",
		lists: "Unlimited lead lists",
		trackers: "Unlimited profile trackers",
		campaigns: "Unlimited campaigns",
	},
	billingNote: {
		monthly: "Unused credits roll over for 1 extra month.",
		annual: "Get all your credits upfront to use freely across the year — plus a 10% discount.",
	},
	payFrequency: {
		label: "Pay",
		yearly: "Yearly (upfront)",
		sixMonths: "Every 6 months",
		threeMonths: "Every 3 months",
	},
	addons: {
		title: "Customize your plan",
		subtitle: "Optional add-ons — top up credits, senders & scrape jobs",
		note: "Add-ons can be purchased anytime after signup from your workspace settings — shown here for reference.",
		topup: {
			name: "Top-up credits",
			desc: "Need more this month? Buy extra credits at your plan's per-credit rate.",
			price: "Same credit rate",
			sub: "based on your plan",
		},
		senders: {
			name: "Additional senders",
			desc: "Each sender connects 1 LinkedIn account + 1 email. Extra email addresses available too.",
			priceMonthly: "29 € / mo",
			subMonthly: "+14 € / mo per extra email",
			priceAnnual: "299 € / year",
			subAnnual: "+149 € / year per extra email",
		},
		scrape: {
			name: "Scrape jobs",
			desc: "Custom website or app scraping, built by our team at a fixed price per list.",
			priceMonthly: "149 € / list",
			priceAnnual: "99 € / list",
			sub: "fixed, any size",
		},
	},
	footer: {
		cancelAnytime: "You can cancel anytime within the trial period. Need more credits later?",
		upgradeAnytime: "Upgrade or top up anytime.",
		vatExcluded: "Prices exclude VAT where applicable.",
	},
	/** The screen Stripe returns to after a plan is paid for (usage.subscription.checkout.done). */
	done: {
		title: "Thank you!",
		headline: "You\u2019re all set.",
		body: "You can now start using Signalist.",
		cta: "To Signalist",
		/**
		 * PREC-3917: shown when finalizing the checkout fails. It must never read as success —
		 * the previous screen congratulated customers whose subscription had not been recorded.
		 */
		failedTitle: "Your payment went through",
		failedBody:
			"We couldn\u2019t finish activating your plan just yet. Your payment is safe and we\u2019re completing this in the background \u2014 try again, or continue and contact us if your plan still isn\u2019t active in a few minutes.",
		retry: "Try again",
	},
};
